var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile"},[_c('qdd-icon',{staticClass:"iconphone_icon",attrs:{"color":"#FD3C3C","size":".8rem"}}),_vm._v(" "+_vm._s(_vm.mobile)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }